export const navSmallscreen = () => {
    const navToggle = document.getElementById('sp-main-toggle');
    const navWrapper = document.getElementById('sp-main-nav');
    const searchToggle = document.getElementById('sp-search-toggle');
    const searchExpanded = searchToggle.getAttribute('aria-expanded');

    navToggle.addEventListener('click', function () {
        if (searchExpanded === 'true') {
            searchToggle.click();
        }

        let expanded =
            navToggle.getAttribute('aria-expanded') === 'true' ? true : false;

        navToggle.setAttribute('aria-expanded', !expanded);
        navWrapper.classList.toggle('sp-main-smallscreen');
    });
};
